export default updateTitle

/** @ngInject */
function updateTitle($rootScope, $timeout) {
    return ({
        restrict: 'A',
        link(scope, element) {
            const listener = function (event, toState) {
                const defaultTitle = 'Plüm énergie : fournisseur d’électricité de nouvelle génération'
                const title = toState.data && toState.data.pageTitle ? `${toState.data.pageTitle} - ${defaultTitle}` : defaultTitle

                const updateText = () => element.text(title)
                return $timeout(updateText, 0, false)
            }

            return $rootScope.$on('$stateChangeSuccess', listener)
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/updateTitle/updateTitle.js